export const constants = {
  ReCaptcha: "6LcLV30pAAAAAKzJqo1PouJULjm28vBsxKFc5PYG",
};
